import type { Margins } from "#public"
import { ToMargins } from "#public"

/** Margins combined edge by edge, each one given as margins or as one value
 * for every edge. */
export const MarginMap = <T>(
  func: (...values: T[]) => T,
  ...margins: (T | Margins<T>)[]
): Margins<T> => {
  const all = margins.map(ToMargins)
  return {
    top: func(...all.map(m => m.top)),
    right: func(...all.map(m => m.right)),
    bottom: func(...all.map(m => m.bottom)),
    left: func(...all.map(m => m.left)),
  }
}
